import moment from "moment";

export function getLocalDateTime(utcTime: string) {
    return moment(moment.utc(utcTime).toDate()).local().format("YYYY-MM-DD HH:mm:ss");
}
